import type { Method } from 'lib/axios';
import { APICallV2Get } from 'reactApp/api/APICall';

export class FolderV2APICall extends APICallV2Get {
    _method = 'folder';
    _type: Method = 'get';
}
